import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import app from 'flarum/forum/app';
export default class ImportRivalsPreviewModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "rivalsToImport", []);
    _defineProperty(this, "rivalsSkipped", []);
    _defineProperty(this, "onConfirm", void 0);
    _defineProperty(this, "loading", false);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.rivalsToImport = this.attrs.rivalsToImport || [];
    this.rivalsSkipped = this.attrs.rivalsSkipped || [];
    this.onConfirm = this.attrs.onConfirm;
  }
  className() {
    return 'ImportRivalsPreviewModal Modal--medium';
  }
  title() {
    return app.translator.trans('bizkaitarra-lineup.forum.rivals.import_preview_title');
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m("div", {
      style: "margin-bottom: 20px;"
    }, m("p", null, app.translator.trans('bizkaitarra-lineup.forum.rivals.import_preview_intro'))), this.rivalsToImport.length > 0 && m("div", {
      style: "margin-bottom: 25px;"
    }, m("h4", {
      style: "font-weight: bold; color: var(--primary-color); margin-bottom: 10px; display: flex; align-items: center; gap: 8px;"
    }, m("i", {
      className: "fas fa-plus-circle"
    }), app.translator.trans('bizkaitarra-lineup.forum.rivals.import_preview_to_import', {
      count: this.rivalsToImport.length
    })), m("div", {
      style: "max-height: 200px; overflow-y: auto; background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08); border-radius: 8px; padding: 10px;"
    }, m("table", {
      style: "width: 100%; border-collapse: collapse;"
    }, m("thead", null, m("tr", {
      style: "border-bottom: 1px solid rgba(255,255,255,0.1); text-align: left; font-size: 0.9em; color: var(--muted-color);"
    }, m("th", {
      style: "padding: 6px 10px;"
    }, app.translator.trans('bizkaitarra-lineup.forum.rivals.column_shield')), m("th", {
      style: "padding: 6px 10px;"
    }, app.translator.trans('bizkaitarra-lineup.forum.rivals.column_name')), m("th", {
      style: "padding: 6px 10px;"
    }, "Divisi\xF3n"))), m("tbody", null, this.rivalsToImport.map((r, i) => m("tr", {
      key: i,
      style: "border-bottom: 1px solid rgba(255,255,255,0.04);"
    }, m("td", {
      style: "padding: 6px 10px;"
    }, r.escudo ? m("img", {
      src: "/assets/extensions/nagusi-match-ratings/escudos/".concat(r.escudo),
      alt: "",
      style: "height: 30px; width: 30px; object-fit: contain;"
    }) : m("i", {
      className: "fas fa-shield-alt",
      style: "color: var(--muted-color); font-size: 1.2em;"
    })), m("td", {
      style: "padding: 6px 10px; font-weight: bold;"
    }, r.name), m("td", {
      style: "padding: 6px 10px; color: var(--muted-color);"
    }, r.division || '1ª'))))))), this.rivalsSkipped.length > 0 && m("div", {
      style: "margin-bottom: 25px;"
    }, m("h4", {
      style: "font-weight: bold; color: var(--muted-color); margin-bottom: 10px; display: flex; align-items: center; gap: 8px;"
    }, m("i", {
      className: "fas fa-exclamation-triangle"
    }), app.translator.trans('bizkaitarra-lineup.forum.rivals.import_preview_skipped', {
      count: this.rivalsSkipped.length
    })), m("div", {
      style: "max-height: 120px; overflow-y: auto; background: rgba(255,255,255,0.01); border: 1px solid rgba(255,255,255,0.05); border-radius: 8px; padding: 10px; font-size: 0.9em; color: var(--muted-color);"
    }, m("ul", {
      style: "margin: 0; padding-left: 20px;"
    }, this.rivalsSkipped.map((r, i) => m("li", {
      key: i,
      style: "margin-bottom: 4px;"
    }, r.name))))), m("div", {
      className: "Form-group",
      style: "display: flex; gap: 10px; justify-content: flex-end; margin-top: 20px;"
    }, m(Button, {
      className: "Button Button--secondary",
      onclick: this.hide.bind(this),
      disabled: this.loading
    }, app.translator.trans('bizkaitarra-lineup.forum.rivals.btn_cancel')), m(Button, {
      className: "Button",
      style: "background: var(--primary-color); color: #fff; font-weight: bold;",
      onclick: () => {
        this.loading = true;
        m.redraw();
        this.onConfirm();
        this.hide();
      },
      loading: this.loading
    }, app.translator.trans('bizkaitarra-lineup.forum.rivals.btn_confirm_import'))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/match-rating/ImportRivalsPreviewModal', ImportRivalsPreviewModal);